export const ids = [
	'draft',
	'complete',
	'cancelled',
	'onHold',
	'pendingFeedback',
	'inProgress',
] as const;
